import {
    Delete,
    Edit,
    Pause,
    PlayArrow,
    Fullscreen,
    FullscreenExit,
} from "@mui/icons-material";
import { Box, Chip, IconButton, Typography } from "@mui/material";
import { useState, useEffect } from "react";

interface StationData {
    station: {
        name: string;
    };
    time: string;
    nreTypeName: string;
    qcvnName: string;
}

interface LedHeaderProps {
    stationData: StationData;
}

const MonitoringImageFooter: React.FC<LedHeaderProps> = ({ stationData }) => {
    const [isPlaying, setIsPlaying] = useState(true);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const handleTogglePlayPause = () => {
        setIsPlaying(!isPlaying);
    };

    const toggleFullscreen = () => {
        if (!isFullscreen) {
            document.documentElement.requestFullscreen();
        } else {
            document.exitFullscreen();
        }
    };

    useEffect(() => {
        const handleFullscreenChange = () => {
            setIsFullscreen(!!document.fullscreenElement);
        };

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape" && document.fullscreenElement) {
                document.exitFullscreen();
            }
        };

        document.addEventListener("fullscreenchange", handleFullscreenChange);
        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.removeEventListener("fullscreenchange", handleFullscreenChange);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: 2,
            }}
        >
            <IconButton onClick={toggleFullscreen} sx={{ color: "white" }}>
                {isFullscreen ? <FullscreenExit /> : <Fullscreen />}
            </IconButton>
        </Box>

    );
};

export default MonitoringImageFooter;
